'use client';

import { useRouter } from 'next/navigation';
import { Button } from '@mui/material';
import { useAppStoreStore } from '@/stores/appstore.store';
import { REVIEW_ROUTES, ROUTES } from '@/constants/path.constants';
import Logo from '@/components/svgs/Logo';

const HeaderLogo = ({ IsUserLoggedIn }: { IsUserLoggedIn: boolean }) => {
  const router = useRouter();
  const { appStores } = useAppStoreStore();

  // appStores 객체를 배열로 변환하고 안전하게 접근
  const appStoresArray = Object.values(appStores || {});
  const hasAppStores = appStoresArray && appStoresArray.length > 0;
  const currentStoreId = hasAppStores ? appStoresArray[0].storeId : null;

  const goToHome = () => {
    if (IsUserLoggedIn) {
      if (currentStoreId && Number(currentStoreId) > -1) {
        router.push(REVIEW_ROUTES.getStoreDashboard(Number(currentStoreId)));
        return;
      }

      router.push(ROUTES.getMainDashboard());
    } else {
      router.push('/');
    }
  };

  return (
    <Button
      style={{
        width: 'fit-content',
        minWidth: 'auto',
        padding: 0,
        overflow: 'visible'
      }}
      onClick={goToHome}
    >
      <Logo className="h-[20px] md:h-[28px] w-[165px] md:w-[231px]" />
    </Button>
  );
};

export default HeaderLogo;
